module.exports = __webpack_public_path__ + "img/layer-notification.363170f.png";